import styled from '@emotion/styled'
export const StyleBreadcrumbWrapper = styled.div<any>`
  display: flex;
  align-items: center;
  ${(props: any) => props?.customStyle}
`

export const StyleBreadcrumb = styled.h2`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`
